import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mapa_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers["X-Access-Token"] = t;
  return cfg;
});

export const errMsg = (e) => e?.response?.data?.detail || "Não foi possível concluir. Verifique sua conexão e tente novamente.";
